export const createExtendedExponentialRampToValueAutomationEvent = (value, endTime, insertTime) => {
    return { endTime, insertTime, type: 'exponentialRampToValue', value };
};
//# sourceMappingURL=create-extended-exponential-ramp-to-value-automation-event.js.map